/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Styles */
/* Services */

/**
 *
 * @param {Object} props
 * @param {String} color
 * @param {String} fontSize
 * @returns
 */
const SectionHeading = ({
  children,
  color = '#FFFFFF',
  fontSize,
  lineHeight,
  ...props
}) => {
  return (
    <Box
      color={color}
      fontWeight={500}
      textAlign={'center'}
      fontSize={fontSize || { base: '24px', md: '2rem' }}
      lineHeight={lineHeight || { base: '28.8px', md: '38.4px' }}
      fontFamily="Geist"
      {...props}
    >
      {children}
    </Box>
  );
};

export default SectionHeading;
